var SCM = SCM || {};

(function (ns, $) {
        
    ns.ChapterEndNotes = function () {

        $('.js-related-object[object-type="end-note"]').on('click', function myFunc() {
            var legacySectionId = $(this).attr('legacysectionid');
            var $footnote = $('div[content-id = "' + legacySectionId + '"]:visible');
            var $paragraph = null;
            if ($footnote != null) {
                $paragraph = $footnote.find('.fn');
            } else {
                return;
            }
            openNoteInModal(legacySectionId, $paragraph);
        });
    };

    function openNoteInModal(legacySectionId, $paragraph) {
        var $displayDiv = $('#ContentTab .js-footnote-modal[legacysectionid= "' + legacySectionId + '"]');
       
        // set focus to modal on open, reset back to currently focused item on modal close
        $displayDiv.off('opened.fndtn.reveal');
        $displayDiv.on('opened.fndtn.reveal', function () {
            $('.js-footnote-modal.open').focus();
        });
        var $focused = $(':focus');
        $displayDiv.on('closed.fndtn.reveal', function () {
            $focused.focus();
            $(this).find('[id^="revealContent"]').html('');
        });

        if ($paragraph != null) {
            var $revealContent = $displayDiv.find('#revealContent-' + legacySectionId);

            if ($revealContent.length && $revealContent.html() === '') {
                $revealContent.append($paragraph.clone());
            }
        }              

        // Scroll to the top the modal
        $displayDiv.foundation('reveal', 'open');
        if ($displayDiv != null && $displayDiv.length) {
            $(window).scrollTop($displayDiv.offset().top - 50);
        }
    }

   
    ns.init = function () {
        ns.ChapterEndNotes();
    };
}

)(SCM.ChapterEndNotes = SCM.ChapterEndNotes || {}, jQuery);